import React from "react"
import {Button, TYPES} from "components/Button"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import styles from "./styles.scss"
import MenuItem from "components/SideNav/MenuItem"
import { companyNewPath, categoryNewPath, adNewPath } from "utils/paths"
import onClickOutside from "react-onclickoutside";

class DropdownButton extends React.Component {
  state = {
    listOpen: false
  }

  toggleList() {
    this.setState(prevState => ({
      listOpen: !prevState.listOpen,
    }))
  }

  handleClickOutside(){
    this.setState({
      listOpen: false
    })
  }

  render() {
    const { listOpen } = this.state
    return (
      <div className={styles.container}>
      <Button onClick={() => this.toggleList()} buttonType={TYPES.SUCCESS}>Skapa ny<FontAwesomeIcon icon={listOpen? "angle-down": "angle-up"} /></Button>
      {listOpen && 
        <div className={styles.dropdownBox}>
          <FontAwesomeIcon icon="caret-up" className={styles.caretUp}/>
          <h4 className={styles.header}>Skapa...</h4>
          <MenuItem path={companyNewPath()} > <FontAwesomeIcon icon="briefcase" className={styles.icon}/><p>Företag</p></MenuItem>
          <MenuItem path={categoryNewPath()} > <FontAwesomeIcon icon="tags" className={styles.icon}/><p>Kategori</p></MenuItem>
          <MenuItem path={adNewPath()} > <FontAwesomeIcon icon="th-large" className={styles.icon}/><p>Annons</p></MenuItem>
        </div>
      }
      </div>
    )
  }
}

export default onClickOutside(DropdownButton)


// WEBPACK FOOTER //
// src/pages/Admin/components/Dropdown/index.jsx